<div class="relative flex flex-grow">
  <div *ngIf="environment.qa" class="absolute top-0 right-0 px-10 m-10 rounded-full shadow-lg bg-gray-lighter">
      <mat-slide-toggle class="m-10 ml-auto" [(ngModel)]="showLocalSimon" (change)="openSimonSso()">Local
          Simon</mat-slide-toggle>
  </div>
  <iframe class="flex-grow w-full min-h-720" [appIframeData] [src]="iframeUrl | safeUrl"></iframe>
</div>

